Button = require 'components/common/button'
Translation = require 'components/mixins/translation'

EditButton = React.createClass
  displayName: 'EditButton'

  mixins: [Translation()]

  propTypes:
    onClick: React.PropTypes.func.isRequired
    title: React.PropTypes.string

  render: ->
    title = @props.title ? @i18n 'actions.edit'
    classes = classNames "edit", @props.className
    <Button className={classes} title={title} onClick={@props.onClick}/>

module.exports = EditButton
